import data from 'constants/locales/en.json';

const BRANCH_TERM_SINGULAR = data?.terms?.branch_term_singular || 'branch';
const BRANCH_TERM_SINGULAR_CAPITALISED =
  data?.terms?.branch_term_singular_capitalised || 'Branch';
const BRANCH_TERM_PLURAL = data?.terms?.branch_term_plural || 'branches';
const BRANCH_TERM_PLURAL_CAPITALISED =
  data?.terms?.branch_term_plural_capitalised || 'Branches';

export const branchTermSingular = BRANCH_TERM_SINGULAR;
export const branchTermSingularCapitalised = BRANCH_TERM_SINGULAR_CAPITALISED;
export const branchTermPlural = BRANCH_TERM_PLURAL;
export const branchTermPluralCapitalised = BRANCH_TERM_PLURAL_CAPITALISED;
